import { lazy } from 'react';
// ----------------------------------------------------------------------

const CustomerRealtionsPage = lazy(() => import('../pages/CustomerRealtions.page'));
const AddCustomerPage = lazy(() => import('../pages/AddCustomer.page'));
const ViewCustomerPage = lazy(() => import('../pages/ViewCustomer.page'));
const EditCustomerPage = lazy(() => import('../pages/EditCustomer.page'));
const ComplaintsAndMsg = lazy(() => import('../pages/complaints-and-messages/ComplaintsAndMsg.pag'));
const AddComplaintPage = lazy(() => import('../pages/AddComplaint.page'));
const CustomerCommunicationPage = lazy(() => import('../pages/CustomerCommunication.page'));
const ListMessage = lazy(() => import('../pages/ListMessage.page'));
const AddMessagePage = lazy(() => import('../pages/AddMessage.page'));
const MarketingPage = lazy(() => import('../pages/Marketing.page'));
const ArchivePage = lazy(() => import('../pages/Archive.page'));

// ----------------------------------------------------------------------

const CustomerRealtionsRoutes = [
    {
        path: 'customer-relations',
        children: [
            { element: <CustomerRealtionsPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: 'add-customer',
                element: <AddCustomerPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'view-customer/:id',
                element: <ViewCustomerPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'edit-customer/:id',
                element: <EditCustomerPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'complaints-and-messages',
                children: [
                    {
                        element: <ComplaintsAndMsg />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add',
                        element: <AddComplaintPage />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                ],
            },
            {
                path: 'customer-communication',
                children: [
                    {
                        element: <CustomerCommunicationPage />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add-message',
                        children: [
                            { element: <AddMessagePage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <AddMessagePage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                    {
                        path: 'list-message',
                        children: [
                            { element: <ListMessage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <ListMessage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'archive',
                element: <ArchivePage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
    {
        path: 'marketing',
        element: <MarketingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { CustomerRealtionsRoutes };
